module.exports = __webpack_public_path__ + "img/systemItemHover.5d9baf52.png";